<section class="form-flow">
  <section class="mx-auto pr-24 pl-24 top max-w-660">
    <section class="back-link">
      <i class="fa-light fa-arrow-left mr-8"></i>

      <a [href]="vm.mmrPageLink" class="button-text" data-testid="back-to-repairs">Back to repairs page</a>
    </section>
    @if (vm.getRebookingData.isLoading()) {
      <app-skeleton-loader class="fill mt-40 h-32"> </app-skeleton-loader>
      <app-skeleton-loader class="fill mt-12 max-w-320 h-32"> </app-skeleton-loader>

      <app-skeleton-loader class="fill mt-20" />

      <app-skeleton-loader class="mt-20 fill p-16">
        <app-skeleton-loader class="fill max-w-240 h-28" />
        <app-skeleton-loader class="fill mt-12" />

        <section class="flex full-width gap-12" style="flex: 1">
          <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
          <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
        </section>

        <section class="flex full-width gap-12" style="flex: 1; justify-content: space-between">
          <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
          <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
        </section>
      </app-skeleton-loader>
    } @else {
      <form (formValueChange)="formValue.set($event)" (submit)="submitBooking()">
        <h1 class="heading-1 mt-24 lg-mt-16">Find a repair date that suits you</h1>
        <section class="card mt-24">
          <h4 class="heading-4 mb-8">Your current engineer visit</h4>
          <p class="body">
            {{ vm.appointments?.currentAppointment | dateTimeslot }}
          </p>
        </section>
        <section class="card mt-24">
          <h4 class="heading-4 mb-8">Pick a new date</h4>
          <app-appointment-picker
            #appointmentPickerComponent
            [data]="{
              daysWithSlots: vm.appointments?.daysWithSlots ?? [],
              earliestSlot: vm.appointments?.earlierSlot ?? '',
              slotsByDate: vm.appointments?.slotsByDate ?? {},
            }"
            [isAllDaySlots]="vm.isAllDaySlots"
            [availabilityStartDate]="vm.availabilityStartDate"
            [slotsToExclude]="vm.slotsToExclude"
            [showBringForwardFlag]="true"
            [disabled]="vm.submittingValue"
            (selectedSlot)="setSelectedSlot($event)"
            (bringForwardFlagChanged)="setBringFowardFlag($event)"
            (appointmentData)="setAppointmentData($event)"
            (initialAppointmentData)="setInitialAppointmentData($event)"
          />

          <input hidden name="selectedSlot" [ngModel]="vm.slotValue" />
          <input hidden name="bringForwardFlag" [ngModel]="vm.bringForwardFlagValue" />

          @if (vm.formSubmitted && !vm.formValid && vm.errorType !== 'timeslot-taken') {
            <div class="warning__invalid__date__container mb-16">
              <i class="fa-light fa-circle-exclamation error-icon"></i>
              <p class="body error-text" data-testid="empty-date-error">Select a date and time.</p>
            </div>
          }

          @if (vm.errorType === 'timeslot-taken') {
            <div class="error__slot-taken__container mt-16 mb-16" data-testid="timeslot-taken-error">
              <div class="warning__slot-taken__title">
                <i class="fa-light fa-circle-exclamation error-icon"></i>
                <p class="body bold">Sorry, that's not available</p>
              </div>
              <div>
                <p class="body">Somebody has just taken the {{ vm.lastAttemptedSlot | dateTimeslot }} slot.</p>
                <p class="body">Please check the calendar again.</p>
              </div>
            </div>
          }

          <div class="divider"></div>

          @if (vm.errorType === 'max-retries-exceeded') {
            <div class="error__max-retries__container mt-16 mb-16" data-testid="max-retries-exceeded-error">
              <div class="warning__slot-taken__title">
                <i class="fa-light fa-circle-exclamation error-icon"></i>
                <p class="body bold">Sorry, there seems to be a problem</p>
              </div>
              <p class="body">We're experiencing technical issues. Please come back later</p>
            </div>
          }

          @if (vm.formValid && vm.errorType !== 'max-retries-exceeded') {
            <div class="warning__slot-taken__container mt-24 md-mt-16 mb-16">
              <div class="warning__slot-taken__container__inner">
                <div class="warning__slot-taken__title" data-testid="rebook-warning">
                  <i class="fa-light fa-circle-exclamation warning-icon"></i>
                  <p class="body bold">Are you sure you want to change your booking?</p>
                </div>
              </div>
            </div>

            <div data-testid="rebook-slot-change">
              <div>
                <p class="body bold">From:</p>
                <p class="body mt-4">
                  {{ vm.appointments?.currentAppointment | dateTimeslot }}
                </p>
              </div>
              <div class="mt-8">
                <p class="body bold">To:</p>
                <p class="body mt-4">
                  {{ vm.slotValue | dateTimeslot }}
                </p>
              </div>
            </div>

            <p class="body mt-16 mb-16">
              You’ll get a booking confirmation by email, and text reminders before the repair.
            </p>
          }

          <div class="button-container">
            @if (vm.errorType === 'max-retries-exceeded') {
              <app-button
                dataLabel="back-to-repairs-button"
                [buttonOptions]="{ type: 'button' }"
                class="min-w-160 continue-button"
                (click)="navigateToRepairsPage()"
              >
                Back to repairs page
                <i class="fa-light fa-arrow-right ml-8"></i>
              </app-button>
            } @else {
              <app-button
                dataLabel="continue-button"
                [buttonOptions]="{
                  type: 'submit',
                  disabled: vm.submittingValue,
                }"
                [loading]="vm.submittingValue"
                class="min-w-160 continue-button"
                (click)="trackContinueClicked()"
              >
                Yes, book this time
                <i class="fa-light fa-arrow-right ml-8"></i>
              </app-button>
            }
          </div>
        </section>
      </form>
    }
  </section>
</section>
